import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fs-5 mb-8" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, nextTick, inject } from "vue";
import {
  TenantOptions,
  getUserTenancy,
  TenantTypes,
} from "@/core/types/TenantTypes";
import UserService from "@/projects/tenant/modules/users/services/UserService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowMoveModal',
  emits: ["user-moved"],
  setup(__props, { expose: __expose, emit: emits }) {

const dialogRef = ref(false);
const partyId = ref<any>(0);
const tenantOptions = ref<any>([]);
const tenantDestination = ref<any>(null);
const isLoading = ref(false);
const user = ref<any>(null);
const afterMoveData = ref<any>(null);
const fecthData = inject<any>("fetchData");
const hideSubmit = ref(false);
const show = async (_partyId: number, _user) => {
  dialogRef.value = true;
  partyId.value = _partyId;
  user.value = _user;
  await nextTick();
  await removeOwnTenancy(_user);
};

const submit = async () => {
  isLoading.value = true;
  try {
    const res = await UserService.migrateUnverifiedUser(
      partyId.value,
      tenantDestination.value
    );
    afterMoveData.value = res;
    fecthData(1);
    hideSubmit.value = true;
    // dialogRef.value = false;
    // emits("user-moved");
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const removeOwnTenancy = async (user) => {
  const tenancy = user?.tenancy;
  tenantOptions.value = TenantOptions.filter(
    (option: any) => option.value !== TenantTypes[tenancy]
  );
};

const hide = () => {
  dialogRef.value = false;
  user.value = null;
  tenantDestination.value = null;
  isLoading.value = false;
  afterMoveData.value = null;
  hideSubmit.value = false;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: "Move",
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (hide())),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (!hideSubmit.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (submit())),
              disabled: tenantDestination.value == null,
              loading: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Current Tenant: "),
        _createElementVNode("b", null, _toDisplayString(user.value.tenancy), 1)
      ]),
      _createVNode(_component_el_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Move to",
            prop: "tenant"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: tenantDestination.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenantDestination).value = $event)),
                placeholder: "Select",
                disabled: isLoading.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(afterMoveData.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", null, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})